import { Button, Modal } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
const QuestionnaireSent = ({ closeModal, isOpen }) => {
    const { t } = useTranslation();
    return (<Modal open={isOpen} size="md" heading={t('financing.questionnaire_sent.title')} onClose={closeModal} footer={<Button onClick={closeModal} variant="primary" label={t('financing.questionnaire_sent.button')}/>}>
            <p className="text-neutral-secondary-initial body-m">{t('financing.questionnaire_sent.message')}</p>
        </Modal>);
};
export default QuestionnaireSent;
